import {InjectionToken} from '@angular/core';

export const TISA_PRODUCTS_URLS = new InjectionToken<string>(
  'Provides TISA Products URLs.',
);
